module.exports = __webpack_public_path__ + "img/carrousel-pacs-2.34cc4558.png";